module.exports = __webpack_public_path__ + "media/images/admin/favicons/android-chrome-512x512-9aeb4531d0d079e56b2a9f4bc17eb6e2.png";